import _ from 'lodash';

export default class DeleteWebhook {
  constructor(context) {
    this.context = context;
  }

  run(webhookId) {
    _.forEach(this.context.stores.webhooks.getAllErrors(), (val, id) => {
      this.context.stores.webhooks.clearErrors(id);
    });

    this.context.gateways.webhook.delete({ webhookId });
    this.context.stores.webhooks.setPendingDelete(webhookId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/webhooks/delete_webhook.js